'use client';
import * as React from 'react';

import createSvgIcon from './createSvgIcon';

const CheckboxUnchecked = createSvgIcon(
  <g fillRule="evenodd">
    <rect fill="#FFF" width="16" height="16" x="4" y="4" rx="2" />
    <path
      fillRule="nonzero"
      d="M18,4 C19.1045695,4 20,4.8954305 20,6 L20,18 C20,19.1045695 19.1045695,20 18,20 L6,20 C4.8954305,20 4,19.1045695 4,18 L4,6 C4,4.8954305 4.8954305,4 6,4 L18,4 Z M18,5 L6,5 C5.48716416,5 5.06449284,5.38604019 5.00672773,5.88337887 L5,6 L5,18 C5,18.5128358 5.38604019,18.9355072 5.88337887,18.9932723 L6,19 L18,19 C18.5128358,19 18.9355072,18.6139598 18.9932723,18.1166211 L19,18 L19,6 C19,5.48716416 18.6139598,5.06449284 18.1166211,5.00672773 L18,5 Z"
    />
  </g>,
  'CheckboxUnchecked'
);

export default CheckboxUnchecked;
